import { render, staticRenderFns } from "./MealAutocomplete.vue?vue&type=template&id=daa9cba4&scoped=true&"
import script from "./MealAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MealAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa9cba4",
  null
  
)

export default component.exports